export enum DecisionStatus {
    Pending = "pending",
    Approved = "approved",
    Rejected = "rejected",
    Deferred = "deferred",
}

export enum DecisionCategory {
    Process = "process",
    Tooling = "tooling",
    Requirement = "requirement",
    Design = "design",
}
